export default __webpack_public_path__ + "static/ucb-b3c5fb76c7120348447922489675023c.png";